<template>
  <div class="">
    <!-- //页面数组循环 -->
    <div v-for="(item, index) in templateList" :key="'zujian' + index">
      <div>
        <el-tag effect="dark" type="warning">{{ item.templateCN }}</el-tag>
        <el-button-group>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-top"
            @click="clickUp(templateList, index)"
            >上移</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="clickDown(templateList, index)"
            >下移<i class="el-icon-arrow-right el-icon-bottom"></i
          ></el-button>
        </el-button-group>
        <el-select
          @change="changeTemplate"
          :value="ThisTempplatesIndex"
          placeholder="请选择"
        >
          <el-option
            v-for="optionsitem in options"
            :key="optionsitem.value"
            :label="optionsitem.label"
            :value="optionsitem.value"
          >
          </el-option>
        </el-select>

        <el-button-group>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-top"
            @click="addTp(templateList, index)"
            >在上面添加</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="addTp(templateList, index + 1)"
            >在下面添加<i class="el-icon-arrow-right el-icon-bottom"></i
          ></el-button>
        </el-button-group>
        <el-button
          size="small"
          type="danger"
          @click="deleteData(templateList, index)"
          ><i class="el-icon-delete"></i>删除</el-button
        >
        <el-button
          size="small"
          type="warning"
          @click="changeShow(item)"
         style="margin-left:0"
          ><i :class="item.show==true?'el-icon-caret-top':'el-icon-caret-bottom'">
            </i>{{item.show==true?'收起':'展开'}}</el-button
        >

                <el-tag style="float:right" effect="dark" type="success">{{ index}}</el-tag>
        <el-tabs stretch type="card" :value="item.show==true?'first':''">
          <el-tab-pane label="浏览"  name="first">
            <!-- 第一个组件 -->
            <Templates1
              v-if="item.templateName == 'templates1'"
              :indata="item"
            ></Templates1>
            <!-- 第二个组件 -->
            <Templates2
              v-if="item.templateName == 'templates2'"
              :indata="item"
            ></Templates2>
            <!-- 第三个组件 -->
            <Templates3
              v-if="item.templateName == 'templates3'"
              :indata="item"
            ></Templates3>
            <!-- 第四个组件 -->
            <Templates4
              v-if="item.templateName == 'templates4'"
              :indata="item"
            ></Templates4>
            <!-- 第五个组件 -->
            <Templates5
              v-if="item.templateName == 'templates5'"
              :indata="item"
            ></Templates5>
            <!-- 第六个组件 -->
            <Templates6
              v-if="item.templateName == 'templates6'"
              :indata="item"
            ></Templates6>
            <!-- 第七个组件 -->
            <Templates7
              v-if="item.templateName == 'templates7'"
              :indata="item"
            ></Templates7>
            <!-- 第八个组件 -->
            <Templates8
              v-if="item.templateName == 'templates8'"
              :indata="item"
            ></Templates8>
            <!-- 第九个组件 -->
            <Templates9
              v-if="item.templateName == 'templates9'"
              :indata="item"
            ></Templates9>
            <!-- 第十个组件 -->
            <Templates10
              v-if="item.templateName == 'templates10'"
              :indata="item"
            ></Templates10>
            <!-- 第十一个组件 -->
            <Templates11
              v-if="item.templateName == 'templates11'"
              :indata="item"
            ></Templates11>    <!-- 第十一个组件 -->
            <Templates12
              v-if="item.templateName == 'templates12'"
              :indata="item"
            ></Templates12>
          </el-tab-pane>
          <el-tab-pane label="编辑" name="second">
            <!-- 遍历Table -->
            <el-form ref="form" :model="form" label-width="80px">
              <div style="background: ; width: 80%; margin: auto">
                <el-form-item
                  :label="tableItem.name"
                  v-for="(tableItem, index2) in item.table"
                  :key="'table' + index2"
                >
                  <el-input
                    v-model="item[tableItem.field]"
                    :value="item[tableItem.field]"
                  ></el-input>
                </el-form-item>
                <div
                  v-for="(childrenItem, index3) in item.children"
                  :key="'children' + index3"
                >
                  <el-descriptions
                    class="margin-top"
                    :title="'组件' + (index3 + 1)"
                    :column="3"
                    border
                  >
                    <template slot="extra">
                      <el-button
                        type="primary"
                        v-if="index3 == 0"
                        size="small"
                        @click="AddChildren(item.children, item.field)"
                        >添加</el-button
                      >
                    </template>
                    <el-descriptions-item
                      v-for="(fieldItem, index4) in item.field"
                      :key="'field' + index4"
                    >
                      <template slot="label">
                        <i class="el-icon-user"></i>
                        {{ fieldItem.name }}
                      </template>
                      <el-input
                        v-model="item.children[index3][fieldItem.field]"
                        :value="item.children[index3][fieldItem.field]"
                      ></el-input>
                    </el-descriptions-item>
                  </el-descriptions>
                </div>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <el-button type="success" @click="SaveData(templateList)">预览</el-button>
  </div>
</template>

<style >
.el-tabs__nav-wrap {
  border: 3px red solid !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #409eff;
  color: white;
}
</style>
<script>
import { options } from "@/demo/options";
import Templates1 from "@/demo/templates1.vue";
import Templates2 from "@/demo/templates2.vue";
import Templates3 from "@/demo/templates3.vue";
import Templates4 from "@/demo/templates4.vue";
import Templates5 from "@/demo/templates5.vue";
import Templates6 from "@/demo/templates6.vue";
import Templates7 from "@/demo/templates7.vue";
import Templates8 from "@/demo/templates8.vue";
import Templates9 from "@/demo/templates9.vue";
import Templates10 from "@/demo/templates10.vue";
import Templates11 from "@/demo/templates11.vue";
import Templates12 from "@/demo/templates12.vue";
export default {
  name: "ShowTemplates",
  props: {
    templateList: Array,
  },
  components: {
    Templates1,
    Templates2,
    Templates3,
    Templates4,
    Templates5,
    Templates6,
    Templates7,
    Templates8,
    Templates9,
    Templates10,
    Templates11,
    Templates12,
  },
  data() {
    return {
      form: "",
      options: options,
      ThisTempplates: {},
      ThisTempplatesIndex: "请选择模板",
    };
  },
  methods: {
    changeShow(item) {
     this.$set(item, 'show', !item.show)
    },
    changeTemplate(change) {
      this.ThisTempplatesIndex = change;
      this.ThisTempplates = options[change].template;
    },
    addTp(list, index) {
      if (index < 0) {
        list.splice(0, 0, this.ThisTempplates);
      } else {
        list.splice(index, 0, this.ThisTempplates);
      }
    },
    deleteData(list, index) {
      list.splice(index, 1);
    },
    AddChildren(list, field) {
      var temp = {};
      for (let index = 0; index < field.length; index++) {
        const element = field[index];
        this.$set(temp, element.field, "");
      }
      list.push(temp);
    },
    // 上移
    clickUp(list, index) {
      if (index > 0) {
        let arr = list;
        arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
      }
    },
    // 下移
    clickDown(list, index) {
      let arr = list;
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
    },
    SaveData(data) {
    }
  },
};
</script>
